import React, { useEffect, useState } from "react";
import CardTable from "../../../components/AdminTable/CardTable";
import { languageHelper } from "../../../config/helperFunctions";
import axios from "axios";
import { apiKey } from "../../../config/config";
import { FaEye } from "react-icons/fa";
import { FaXmark } from "react-icons/fa6";

function InvoiceLogs() {
  const user = JSON.parse(localStorage.getItem("rms-admin"));
  const [data, setData] = useState([]);
  const [zatccaLogs, setZatccaLogs] = useState(null);

  const columns = [
    {
      header: "SN",
      cell: (row) => row.row.index + 1,
    },
    {
      header: languageHelper("Date"),
      accessorKey: "created_at",
    },
    {
      header: languageHelper("Reference No"),
      accessorKey: "sale_id",
    },
    {
      header: languageHelper("Customer"),
      accessorKey: "sale",
      cell: (row) => row.getValue()?.customer?.name,
    },
    {
      header: languageHelper("Zatca Status"),
      accessorKey: "response_data",
      cell: (row) => (
        <button
          className="p-2 rounded bg-d-bg text-white mx-auto"
          onClick={() => setZatccaLogs(row.getValue())}
        >
          <FaEye />
        </button>
      ),
    },
  ];

  const parseToJSON = (data) => {
    try {
      const parsed = typeof data === "string" ? JSON.parse(data) : data;

      return JSON.stringify(parsed, null, 2);
    } catch (e) {
      return data; // fallback if parsing fails
    }
  };

  useEffect(() => {
    axios
      .get(`${apiKey}/api/rms/admin/zatca/logs`, {
        headers: {
          Authorization: `Bearer ${user?.token}`,
        },
      })
      .then((res) => {
        setData(res.data);
      })
      .catch((err) => {
        console.error(err);
      });
  }, [user?.token]);
  return (
    <>
      <main>
        <CardTable
          data={data}
          columns={columns}
          heading={languageHelper("Invoice Logs")}
        />
      </main>
      {zatccaLogs && (
        <div
          className="fixed top-0 left-0 z-30 min-h-screen w-full bg-black bg-opacity-50 backdrop-blur-md grid place-items-center p-4"
          onClick={() => setZatccaLogs(null)}
        >
          <div
            className="bg-white p-4 rounded-lg max-w-2xl w-full relative"
            onClick={(e) => e.stopPropagation()}
          >
            <button
              className="absolute top-2 right-2"
              onClick={() => setZatccaLogs(null)}
            >
              <FaXmark />
            </button>
            <div>
              <h1 className="text-gray-800 font-semibold">Zatca Status JSON</h1>
              <hr />
              <pre className="text-sm overflow-auto bg-gray-100 p-4 rounded max-h-72 h-full my-2">
                {(() => parseToJSON(zatccaLogs))()}
              </pre>
            </div>
          </div>
        </div>
      )}
    </>
  );
}

export default InvoiceLogs;
